import R from 'ramda';
import debugLib from 'debug';

import { reducerWrapper } from '../support/utils';

import {
  GET_AD_LINKS,
  UPDATE_AD_LINKS,
  ARCHIVE_LINK
} from '../actions/AdLinksActions';

const debug = debugLib('AdLinksReducer');

var INIT_STATE = {
  loading: false,
  error: null,
  links: undefined,
  hasLinksLoaded: false
};

function Handler(state = INIT_STATE, action) {
  debug('Receive action type', action.type);
  const { data } = action;
  const { links } = state;

  switch (action.type) {
    case GET_AD_LINKS.response:
      return { ...state, links: data, loading: false, hasLinksLoaded: true };

    case UPDATE_AD_LINKS:
      if (!links) {
        return state;
      }

      let updatedLink;

      let index = R.findIndex(R.propEq('id', data.link_id), links);

      if (index !== -1) {
        // if link exists, update the data in list of links
        // don't update the link id and date
        updatedLink = {
          ...links[index],
          data: { ...data.data },
          archived: data.archived
        };
      } else {
        index = links.length;
        // date isn't being returned by service, so we must add it
        updatedLink = R.assoc('date', Date.now(), data);
      }

      const updatedLinks = [
        ...links.slice(0, index),
        updatedLink,
        ...links.slice(index + 1)
      ];

      return {
        ...state,
        links: updatedLinks,
        loading: false
      };

    case ARCHIVE_LINK.response:
      if (!links) {
        // links have not loaded yet
        return state;
      }

      const archivedIndex = R.findIndex(R.propEq('id', data.link_id), links);

      const archivedLink = {
        ...links[archivedIndex],
        archived: data.archived
      };

      const linksWithArchived = [
        ...links.slice(0, archivedIndex),
        archivedLink,
        ...links.slice(archivedIndex + 1)
      ];

      return {
        ...state,
        links: linksWithArchived,
        loading: false
      };

    default:
      return state;
  }
}

const AdLinks = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_AD_LINKS, UPDATE_AD_LINKS, ARCHIVE_LINK],
  error: [GET_AD_LINKS, UPDATE_AD_LINKS, ARCHIVE_LINK],
  resetOn: ['APP_CHANGE']
});

export default AdLinks;
